/**
 * Interface preferences.
 *
 * Note what is **not** here: liturgical, export and notification language. Those are three separate
 * axes owned by three different things — the Liturgy, the export request, and each recipient — and
 * putting any of them behind "my preferences" would be the conflation
 * docs/engineering/12-localization.md warns about.
 */

import type { LaunchLanguage } from '@pius/contracts';

import { request } from '../../api/client';

export interface Preferences {
  /** The chrome only: buttons, labels, validation. Yours alone. */
  interface_language: LaunchLanguage;
  navigation: string;
  workspace_layout: string;
  density: string;
}

export function fetchPreferences(): Promise<Preferences> {
  return request('/me/preferences');
}

/** Partial: the screen saves one control at a time, so a stale tab cannot revert another setting. */
export function savePreferences(patch: Partial<Preferences>): Promise<Preferences> {
  return request('/me/preferences', { method: 'PUT', body: JSON.stringify(patch) });
}
